import AbstractTrack from './abstract.track';
export default class SimpleTrack extends AbstractTrack {
    constructor($injector, simpleTrackEvent) {
        super($injector);
        this.simpleTrackEvent = simpleTrackEvent;
        this.eventNameSegment = simpleTrackEvent.segmentName;
    }
    start() {
        this.$rootScope.$on(this.simpleTrackEvent.rootScopeEvent, (e, customTrackData = {}) => {
            this.trackSegment(customTrackData, !!this.simpleTrackEvent.skipSegmentTrackData);
        });
    }
}
